import { CardsViewAttributeOption, CardsViewSortOption } from "@organisms/ObjectsView/CardsView/CardsView.types"

export const PURCHASE_ORDER_CARDS_VIEW_ATTRIBUTE_OPTIONS: CardsViewAttributeOption<PurchaseOrder>[] = [
    { name: "subtotal", label: "Subtotal" },
    { name: "date_issued", label: "Issued" },
    { name: "item_count", label: "Item Count" },
    { name: "associated_estimates", label: "Estimate Count" },
    { name: "associated_jobs", label: "Job Count" },
    { name: "associated_invoices", label: "Invoice Count" },
    { name: "last_modified_at", label: "Last Modified" },
    { name: "labels", label: "Labels" },
]

export const PURCHASE_ORDER_CARDS_VIEW_SORT_OPTIONS: CardsViewSortOption<PurchaseOrder>[] = [
    { name: "id", label: "ID" },
    { name: "vendor_name", label: "Purchasing Vendor" },
    { name: "vendor_internal_id", label: "Vendor PO ID" },
    { name: "status_label", label: "Status" },
    { name: "item_count", label: "Items" },
    { name: "subtotal", label: "Amount" },
    { name: "last_modified_at", label: "Last Modified" },
    { name: "date_issued", label: "Issued" },
    { name: "estimated_arrival_time", label: "Est. Arrival" },
    { name: "payment_terms", label: "Payment Terms" },
    { name: "last_sent_at", label: "Sent" },
    { name: "last_acknowledged_at", label: "Acknowledged" },
    { name: "last_in_transit_at", label: "In Transit" },
    { name: "last_delivered_at", label: "Delivered" },
    { name: "last_stocked_at", label: "Stocked" },
    { name: "last_paid_at", label: "Paid" },
    { name: "last_cancelled_at", label: "Cancelled" },
    { name: "last_viewed", label: "Seen" },
]
